import request from './index'

export function login(account, password, captchaId, captchaCode) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {
      account,
      password,
      captcha_id: captchaId,
      captcha_code: captchaCode
    }
  })
}

export function getCaptcha() {
  return request({
    url: '/auth/captcha',
    method: 'get'
  })
}

export function getMe() {
  return request({
    url: '/auth/me',
    method: 'get'
  })
}

export function getMyPermissions() {
  return request({
    url: '/auth/me/permissions',
    method: 'get'
  })
}

export function changePassword(data) {
  return request({
    url: '/auth/password',
    method: 'put',
    data
  })
}

export function sendResetCode(email) {
  return request({
    url: '/auth/send-reset-code',
    method: 'post',
    data: { email }
  })
}

export function resetPassword(email, code, newPassword) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data: { email, code, new_password: newPassword }
  })
}